import { SUPPORTED_LANGUAGES } from '@inflearn/i18n-tools';
import { useTranslation } from 'react-i18next';
import PolicyLayout from '../../../components/layout/PolicyLayout';
import { PolicyContent } from '../../../components/pages/policy/PolicyContent';
import { getCdnTranslationProps } from '../../../utils/server/i18n/getCdnTranslationProps';

export const getStaticProps = async () => {
  const revalidateTime = 60;

  return {
    props: {
      ...(await getCdnTranslationProps(SUPPORTED_LANGUAGES.ja, ['common'])), // NOTE: 일본 페이지에서만 사용하는 약관입니다.
    },
    revalidate: revalidateTime,
  };
};

export default function PolicySpecifiedCommercialTransactionsPage() {
  const { t } = useTranslation();

  const title = '메타.특정 상거래법.제목';
  const description = '메타.특정 상거래법.설명';

  return (
    <PolicyLayout
      meta={{
        title,
        description,
      }}
    >
      <PolicyContent
        title={t('특정 상거래법.long')}
        type="TRADE_LAW" // TODO: API 연결할 때 변경하기.
        period="PREVIOUS"
      />
    </PolicyLayout>
  );
}
